{
  "title": "Entrega estimada",
  "deliverTo": "Entregar en",
  "orderWithin": "Pide dentro de",
  "toReceiveBy": "para recibirlo antes del",
  "estimatedDelivery": "Entrega estimada",
  "freeShipping": "Envío gratuito",
  "loading": "Comprobando tiempos de entrega…",
  "noDataHeading": "Estimación de entrega no disponible",
  "noDataSummary": "No pudimos encontrar información de entrega para este destino.",
  "errorHeading": "Algo salió mal",
  "errorSummary": "No se pudieron cargar las estimaciones de entrega. Inténtelo de nuevo más tarde.",
  "editZip": "Introducir código postal",
  "changeZip": "Cambiar",
  "applyZip": "Aplicar",
  "zipPlaceholder": "Código postal",
  "dayRange": "{min}–{max} días laborables",
  "singleDay": "{count} día laborable",
  "tomorrow": "Mañana",
  "today": "Hoy"
}
